<template>
  <v-overlay v-model="loading" z-index="999">
    <v-progress-circular
      :size="80"
      width="5"
      color="white"
      indeterminate
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.$root.$on('loading', this.setValue)
  },
  beforeDestroy() {
    this.$root.$off('loading', this.setValue)
  },
  methods: {
    setValue(value) {
      this.loading = value
    }
  }
}
</script>